import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {pullRequestsCommitsRoute} from '../routes/commits-route'
import type {PullRequestAliveData} from './use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'

const pullRequestFilter = (data: PullRequestAliveData) => Boolean(data.event_updates?.git_updated)
const emptyQueryKey = [] as const

interface CommitsLiveUpdateChannels {
  commitHeadShaChannel: string
  pullRequestChannel: string
}

export function useCommitsLiveUpdates(
  {commitHeadShaChannel, pullRequestChannel}: CommitsLiveUpdateChannels,
  throttleTimeout?: number,
): void {
  const queryKey = useRouteQueryKey(pullRequestsCommitsRoute, 'mainQuery')
  const commitsQueryKey = queryKey ?? emptyQueryKey

  // Status and check updates on the head commit channel don't include `event_updates`, so they can't be filtered.
  useInvalidateOnAliveUpdate(queryKey ? commitHeadShaChannel : '', commitsQueryKey, {throttleTimeout})
  useInvalidateOnAliveUpdate(queryKey ? pullRequestChannel : '', commitsQueryKey, {
    filter: pullRequestFilter,
    throttleTimeout,
  })
}
